var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93945 24.999C4.93945 25.6387 5.19359 26.2523 5.64595 26.7046C6.09831 27.157 6.71185 27.4111 7.35159 27.4111H10.5718C11.2115 27.4111 11.8251 27.157 12.2774 26.7046C12.7298 26.2523 12.9839 25.6387 12.9839 24.999V22.02C12.9839 20.9548 13.4071 19.9333 14.1602 19.1801C14.9134 18.4269 15.935 18.0038 17.0001 18.0038C18.0653 18.0038 19.0868 18.4269 19.84 19.1801C20.5932 19.9333 21.0163 20.9548 21.0163 22.02V24.999C21.0163 25.6387 21.2705 26.2523 21.7228 26.7046C22.1752 27.157 22.7887 27.4111 23.4285 27.4111H26.6487C27.2884 27.4111 27.9019 27.157 28.3543 26.7046C28.8067 26.2523 29.0608 25.6387 29.0608 24.999V13.2398C29.061 12.6429 28.9136 12.0553 28.6316 11.5292C28.3496 11.0031 27.9419 10.5549 27.4447 10.2247L19.0022 4.60438C18.4089 4.21025 17.7124 4 17.0001 4C16.2878 4 15.5914 4.21025 14.9981 4.60438L6.55558 10.2247C6.0584 10.5549 5.65064 11.0031 5.36866 11.5292C5.08668 12.0553 4.93923 12.6429 4.93945 13.2398V24.999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/_home.5263e303339dc521c27171452b225a4b.svg";
export { ForwardRef as ReactComponent };